import cls from 'classnames';
import './index.scss';

export const Block = ({ component: Component = 'div', className = '', color = 'light', children, square = false }) => (
    <Component className={cls('item-block', `color-${color}`, square && 'square', className)}>
        {children}
    </Component>
);